module.exports = function serializeMessage(message) {
  return JSON.stringify(message);
};
